import { Layout as BaseLayout } from "antd";
import { FC, Suspense } from "react";
import { Outlet } from "react-router";

import { SkeletonPage } from "@/components/SkeletonPage";
import { BreadcrumbsProvider } from "@/components/Breadcrumbs/BreadcrumbsContext";

import { Header } from "./Header";
import { Sider } from "./Sider";

import "./index.less";

const CustomerLayout: FC = () => {
  return (
    <BreadcrumbsProvider>
      <BaseLayout className="customer-layout">
        <BaseLayout.Sider width={114} theme="dark">
          <Sider />
        </BaseLayout.Sider>
        <BaseLayout>
          <BaseLayout.Header>
            <Header />
          </BaseLayout.Header>
          <BaseLayout.Content>
            <Suspense fallback={<SkeletonPage />}>
              <Outlet />
            </Suspense>
          </BaseLayout.Content>
        </BaseLayout>
      </BaseLayout>
    </BreadcrumbsProvider>
  );
};

export default CustomerLayout;
